import { DestroyRef, inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  BehaviorSubject,
  distinctUntilChanged,
  map,
  tap,
  withLatestFrom,
} from 'rxjs';
import { AppState } from '../state/app.state';
import { selectFeedSearchQuery } from '../state';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Actions, ofType } from '@ngrx/effects';
import { objectChanged } from '../state/core.actions';

@Injectable({
  providedIn: 'root',
})
export class AdvancedSearchService {
  private searchQuerySubject = new BehaviorSubject<string>('');
  searchQuery$ = this.searchQuerySubject.asObservable();

  private store = inject(Store<AppState>);
  private actions$ = inject(Actions);
  private destroyRef = inject(DestroyRef);

  constructor() {
    this.actions$
      .pipe(
        ofType(objectChanged),
        withLatestFrom(this.store.select(selectFeedSearchQuery)),
        map(([, query]) => query),
        distinctUntilChanged(),
        tap((query) => this.setQuery(query)),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }

  setQuery(query: string) {
    this.searchQuerySubject.next(query);
  }
}
